import * as BaseLogoUtils from './utils';
export const CFBaseLogoUtils = BaseLogoUtils;
